import styled from 'styled-components';
import { ThemeType } from './styles/theme';

export const CalloutText = styled.p`
  color: ${({ theme }: { theme: ThemeType }) => theme.colors.disabledText};
  font-size: ${({ theme }: { theme: ThemeType }) => theme.defaultFontSize};
  font-style: italic;
`;
